<template>
  <div class="contact-search-categories-filter">
    <button
      type="button"
      :class="{
          'btn': true,
          'contact-search-categories-filter__button': value.length,
          'contact-search-categories-filter__button--selected': !value.length,
        }"
      :aria-selected="(!value.length).toString()"
      @click="clearSelectedCategories"
    >
      All
    </button>
    <button
      v-for="category in categories"
      type="button"
      :class="{
          'btn': true,
          'contact-search-categories-filter__button': !categoryIsSelected(category.id),
          'contact-search-categories-filter__button--selected': categoryIsSelected(category.id),
        }"
      :aria-selected="categoryIsSelected(category.id).toString()"
      @click="toggleCategoryInSelection(category.id)"
    >
      {{ category.name }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'ContactSearchCategoriesFilter',

  model: {
    prop: 'value',
    event: 'change',
  },

  props: {
    categories: Array,
    value: Array,
  },

  methods: {
    clearSelectedCategories () {
      this.$emit('change', [])
    },
    toggleCategoryInSelection (category) {
      if (this.categoryIsSelected(category)) {
        const internalValue = this.value.filter(i => i !== category)
        this.$emit('change', internalValue)
      } else {
        const internalValue = this.value
        internalValue.push(category)
        this.$emit('change', internalValue)
      }
    },
    categoryIsSelected (category) {
      return this.value.indexOf(category) !== -1
    },
  },
}
</script>
